import {ref} from 'vue';
import {useQuery, useMutation, useQueryClient} from '@tanstack/vue-query';
import axios from 'axios';
import {errorToast, successToast} from "@/composables/useToasts";
import Swal from "sweetalert2";

const isYearly = ref(false);
const billingPeriod = ref(false);
const terminateAt = ref(null);

export const useBillingPackages = () => {
    const queryClient = useQueryClient();

    const query = useQuery({
      queryKey: ['billing-packages'],
      queryFn: async () => {
        const {data} = await axios.get('/ajax/v2/billing/packages');
        billingPeriod.value = data.billing_period;
        isYearly.value = billingPeriod.value === 'YEAR';
        return data.data;
      },
    });

    const pauseWebsiteMutation = () => useMutation({
      mutationFn: async () => await axios.post('/ajax/v2/billing/package/website/pause'),
      onSuccess: () => {
        successToast('Your website has been downgraded successfully.');
        queryClient.invalidateQueries({queryKey: ['current-website']});
        queryClient.invalidateQueries({queryKey: ['billing-packages']});
        queryClient.invalidateQueries({queryKey: ['paused-price']});

        // Clear terminate at as pausing will clear cancellation (saves page refresh)
        terminateAt.value = null;
      },
      onError: (error) => {
        if (error.response.status === 402) {
          return;
        }

        const errorMessage = error.response?.data?.message || 'Something went wrong while downgrading your website.';
        errorToast(errorMessage);
      },
    });

    const unpauseWebsiteMutation = () => useMutation({
      mutationFn: async () => await axios.post('/ajax/v2/billing/package/website/unpause'),
      onSuccess: () => {
        successToast('Your website has been upgraded successfully.');
        queryClient.invalidateQueries({queryKey: ['current-website']});
        queryClient.invalidateQueries({queryKey: ['billing-packages']});
        queryClient.invalidateQueries({queryKey: ['paused-price']});

        // Clear terminate at as unpausing will clear cancellation (saves page refresh)
        terminateAt.value = null;
      },
      onError: (error) => {
        if (error.response.status === 402) {
          return;
        }

        const errorMessage = error.response?.data?.message || 'Something went wrong while upgrading your website.';
        errorToast(errorMessage);
      },
    });

    return {
      isYearly,
      billingPeriod,
      terminateAt,
      pauseWebsiteMutation,
      unpauseWebsiteMutation,
      ...query,
    };
  }
;
